import { render, staticRenderFns } from "./RequestStoreFooter.vue?vue&type=template&id=8bad5226"
import script from "./RequestStoreFooter.vue?vue&type=script&lang=js"
export * from "./RequestStoreFooter.vue?vue&type=script&lang=js"
import style0 from "./RequestStoreFooter.vue?vue&type=style&index=0&id=8bad5226&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports